import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Table, Input, DatePicker, Space, Card, Row, Col, Switch, Image, Checkbox, Button, message } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ExclamationCircleOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined } from "@ant-design/icons";
import AdminLessonCategoryModal from "./components/AdminLessonCategoryModal";
import NewTable from "./components/NewTable";

const LessonCategoryList = () => {
    const { confirm } = Modal;
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [search, set_search] = useState('');
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [datas, setDatas] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const columns = [
        {
            title: '分類名稱',
            key: 'name',
            dataIndex: 'name',
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Col>
                        <p style={{ fontSize: '24px', fontWeight: 400 }}>{record.name}</p>
                        {/* <span style={{ fontSize: '18px', fontWeight: 400 }}>授課老師:{record.teacher}</span> */}
                    </Col>
                </>
            )
        },
        {
            title: '分類說明',
            key: 'note',
            dataIndex: 'note',
            align: 'center',
        },
        {
            title: '操作',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { setTitle('修改'); setEdit(true); setOpen(true); setEditCard(record); }} >編輯</Button>
                    <Button danger type="text" onClick={() => showMessageAll(record.lesson_id)}>刪除</Button>
                </>
            )
        },
    ];
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selectedRowKeys.length !== 0) {
                setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);

        },

    };
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true)
        axios
            .get(`/cramSchool/api/lesson_category`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                /* const data_tmp = [...response.data];
                data_tmp && data_tmp.map((value, i) => {
                    let teacher = '';
                    value.teachers.length != 0 && value.teachers.map((tmp) => {
                        teacher += `${tmp.teacher_name}、`
                    })
                    teacher = teacher.slice(0, -1);
                    data_tmp[i]['teacher'] = teacher;
                }) */
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally((error) => {
                set_loading(false)
            })
    }
    const handleOnDelete = () => {
        const deleterow = [];
        selectedRowKeys && selectedRowKeys.map((value) => {
            deleterow.push({ 'lesson_category_id': value });
        })
        // console.log(deleterow);
        axios
            .delete(`/cramSchool/api/lesson_category`, {
                data: deleterow
            })
            .then((response) => {
                // console.log(response)
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_datas();
                }
            })
    }
    const handleEdit = () => {
        if (editcard.name == '' || editcard.name == undefined) {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '修改失敗，請填寫名稱',
            });
        } else {
            axios
                .patch(`/cramSchool/api/lesson_category`, [editcard])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        get_datas();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        get_datas();
                    }
                })
        }
        // console.log(editcard);
    }

    const handleSubmit = () => {
        if (editcard.name == '' || editcard.name == undefined) {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫名稱',
            });
        } else {
            axios
                .post(`/cramSchool/api/lesson_category`, [editcard])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_datas();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_datas();
                    }
                })
        }
        // console.log(editcard);
    }
    const showMessageAll = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleDelete();
            },
            centered: true
        });
    };
    const handleDelete = (id) => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys.map((value) => {
                const data_tmp = {};
                data_tmp['lesson_category_id'] = value;
                deleterow.push(data_tmp);
            })
            axios
                .delete(`/cramSchool/api/lesson_category`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status == 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        get_datas();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        get_datas();
                    }
                })
        }
    }
    const handleOnAddRow = () => {
        setTitle('新增'); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true)
    }
    useEffect(() => {
        get_datas()
    }, []);
    return (
        <>
            {contextHolder}
            <AdminLessonCategoryModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}
            />
            <Row gutter={[8, 16]} style={{ padding: '20px' }}>
                <Col span={24}>
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'ClassList'}
                        force_reload={force_reload}
                        style={{ cursor: 'pointer' }}
                        getData={get_datas}
                        datas={datas}
                        columns={columns.concat(extra_columns || [])}
                        tableLayout={'fixed'}
                        scroll={{ x: 'max-content' }}
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        add_button_title={'新增課程分類'}//新增按鈕上的名稱
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        handleOnDeleteRow={handleDelete}//多筆刪除
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        rowKey={'lesson_category_id'}
                    />
                    {/* <Card
                    >
                        {datas && datas.map((value, index) =>
                            <>
                                <Row>
                                    <Col span={2}><Checkbox value={value.lesson_category_id} onChange={onChangebox} style={{ weight: '46px', height: '46px' }}></Checkbox></Col>
                                    <Col span={6}>
                                        <p style={{ fontSize: '24px', fontWeight: 400 }}>{value.name}</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <span style={{ fontSize: '18px', fontWeight: 400 }}>授課老師:</span>{value.teachers && value.teachers.map((data_tmp, data_tmp_index) =>
                                            <span style={{ fontSize: '18px', fontWeight: 400 }}>{data_tmp.teacher_name}&nbsp;</span>
                                        )}
                                        <p style={{ fontSize: '18px', fontWeight: 400 }}>授課老師:{value.teachers}</p>
                                    </Col>
                                    <Col span={10}></Col>
                                    <Col span={6}>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <Button style={{ backgroundColor: 'rgba(255, 255, 232, 1)' }} onClick={e => { setTitle('修改'); setEdit(true); setOpen(true); setData({ lesson_category_id: value.lesson_category_id, name: value.name }) }} icon={<EditOutlined />}>編輯</Button>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>最後修改10月8日12:30</p>
                                    </Col>
                                </Row>
                                <hr></hr>
                            </>
                        )}
                    </Card> */}
                </Col>
            </Row>
        </>
    );
};

export default LessonCategoryList;